import {
  BUNDLE_NODE_HEIGHT,
  INBOX_NODE_HEIGHT,
  InboxGraphNode,
  InboxGraphNodeTypesEnum,
  MAIN_INBOX_NODE_HEIGHT,
} from './inboxGraphTypes';

/**
 * Returns a node's height in an inbox graph.
 */
export function getNodeHeight(node: InboxGraphNode) {
  switch (node.type) {
    case InboxGraphNodeTypesEnum.INBOX:
    case InboxGraphNodeTypesEnum.ANY_INBOX:
    case InboxGraphNodeTypesEnum.CHANNEL:
      return INBOX_NODE_HEIGHT;
    case InboxGraphNodeTypesEnum.MAIN_INBOX:
      return MAIN_INBOX_NODE_HEIGHT;
    case InboxGraphNodeTypesEnum.BUNDLES: {
      const {bundles} = node;
      const nbBundles = bundles.length;
      // We only display up to 4 bundle's name, if there are more than 4, only display 3 names and an additional cell with +X bundles.
      return Math.min(nbBundles, 4) * BUNDLE_NODE_HEIGHT + 4;
    }
    default:
      return 15;
  }
}
